'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Badge", {
    enumerable: true,
    get: function() {
        return Badge;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useBadge = require("./useBadge");
const _useBadgeStylesstyles = require("./useBadgeStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _renderBadge = require("./renderBadge");
const Badge = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useBadge.useBadge_unstable)(props, ref);
    (0, _useBadgeStylesstyles.useBadgeStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useBadgeStyles_unstable')(state);
    return (0, _renderBadge.renderBadge_unstable)(state);
});
Badge.displayName = 'Badge';
